export * from "./getOutrightCardProps";